<template>
	<div class="leaderboard">
		<FieldInput name="name" :placeholder="placeholder" v-model="value.name" />
		<div class="inner">
			<FieldSelect
				name="leaderboardRange"
				:options="rangeOpts"
				placeholder="Select"
				v-model="value.range"
			/>
			<FieldSelect name="leaderboardSize" :options="sizeOpts" v-model="value.limit" />
		</div>
	</div>
</template>

<script>
import { LeaderboardRange } from 'recycle-race-common/lib/enums'
import { LeaderboardTitle } from 'recycle-race-common/lib/labels'
import FieldInput from '@/components/FieldInput'
import FieldSelect from '@/components/FieldSelect'

const RangeLabels = {
	[LeaderboardRange.DAILY]: 'Daily',
	[LeaderboardRange.WEEKLY]: 'Weekly',
	[LeaderboardRange.MONTHLY]: 'Monthly',
	[LeaderboardRange.ALL_TIME]: 'All-time',
	[LeaderboardRange.EVENT_SPAN]: 'Whole event',
}

const LeaderboardSizes = [5, 10, 15, 20]

export default {
	name: 'LeaderboardForm',
	props: {
		value: {
			type: Object,
			validator: v => !v.range || v.range in LeaderboardRange,
		},
		ranges: Array,
	},
	data() {
		return {
			sizeOpts: LeaderboardSizes.map(value => ({
				label: value,
				value,
			})),
		}
	},
	computed: {
		placeholder() {
			return LeaderboardTitle[this.value.range] || 'Title (optional)'
		},
		rangeOpts() {
			return this.ranges.map(value => {
				const label = RangeLabels[value]
				return { label, value }
			})
		},
	},
	components: {
		FieldInput,
		FieldSelect,
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/layout';
@import '~scss/mq';

.leaderboard {
	@include row;
	padding: 0.5rem;
}

.inner {
	@include row(md);
}

::v-deep {
	input,
	select {
		background-color: white;
	}
}
</style>
